import { get } from '@/api/request'

export const getFrontendMenus = () => {
    return get('/api/solve-x-ai/appconfig/frontend-menus')
}
